/**
 * 汽运入库多维度运输数据智能统计
 * POST /api/produce/mult-transport-data-statistics（与 axios baseURL 组合后同发运总览看板）
 */
import request from '@/router/axios'

const API = '/api/produce/mult-transport-data-statistics'

function unwrap(res) {
  const body = res && res.data
  if (body && Object.prototype.hasOwnProperty.call(body, 'data')) return body.data
  return body
}

/**
 * @param {{ startDate?: string, endDate?: string }} params yyyy-MM-dd
 */
export function fetchMultTransportStatistics(params = {}) {
  return request({
    url: API,
    method: 'post',
    data: params
  }).then(unwrap)
}
